export default __webpack_public_path__ + "static/media/daft-punk-1.3b4f9bc3.png";